import * as React from 'react'
import {createContext, useContext, useState} from 'react'

export interface VerticalPositionContextType {
  centerY: number | null
  setCenterY: React.Dispatch<React.SetStateAction<number | null>>
  topChildCenterY: number | null
  setTopChildCenterY: React.Dispatch<React.SetStateAction<number | null>>
  selectedItemId: string | null
  setSelectedItemId: (itemId: string | null) => void
}

const VerticalPositionContext = createContext<VerticalPositionContextType | null>(null)

export function VerticalPositionProvider({children}: {children: React.ReactNode}) {
  const [centerY, setCenterY] = useState<number | null>(null)
  const [topChildCenterY, setTopChildCenterY] = useState<number | null>(null)
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null)

  return (
    <VerticalPositionContext.Provider
      value={{centerY, setCenterY, topChildCenterY, setTopChildCenterY, selectedItemId, setSelectedItemId}}
    >
      {children}
    </VerticalPositionContext.Provider>
  )
}

// The useCenterY() hook provides the centerY value,
// which represents the vertical center position of the reference element,
// likely the PositionAwareItem components in the LeftPanel of a RuleBuilder pattern.
// This centerY value serves as the target position for the indicator caret of a RuleDetail.
export function useCenterY(): VerticalPositionContextType {
  const context = useContext(VerticalPositionContext)
  if (!context) {
    throw new Error(
      'useCenterY must be used within a VerticalPositionProvider. Wrap your layout component in a VerticalPositionProvider. See https://fuegokit.design/react/screens/rule-builder-patterns.'
    )
  }
  return context
}
